import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';

interface IAthleteEventStatusBadgeProps extends BadgeProps {
  isWaitlisted?: boolean;
  isCheckedIn?: boolean;
  isReserved?: boolean;
  isLateCancel?: boolean;
  isNoShow?: boolean;
  isCredited?: boolean;
  waitlistOrder?: number | null;
  isClass?: boolean;
}

const AthleteEventStatusBadge = ({
  isWaitlisted = false,
  isCheckedIn = false,
  isReserved = false,
  isLateCancel = false,
  isNoShow = false,
  isCredited = true,
  isClass = false,
  waitlistOrder,
  ...props
}: IAthleteEventStatusBadgeProps): JSX.Element | null => {
  if (isWaitlisted) {
    return (
      <Badge size='md' variant='filled' color='orange' {...props}>
        Waitlisted #{waitlistOrder}
      </Badge>
    );
  }
  if (isLateCancel) {
    return (
      <Badge size='md' variant='filled' color='red' {...props}>
        Late Cancel
      </Badge>
    );
  }
  if (isNoShow) {
    return (
      <Badge size='md' variant='filled' color='red' {...props}>
        No Show
      </Badge>
    );
  }
  if (!isCredited) {
    return (
      <Badge size='md' variant='filled' color='orange' {...props}>
        Uncredited Reservation
      </Badge>
    );
  }
  if (isCheckedIn) {
    return (
      <Badge size='md' variant='filled' color='green' {...props}>
        Checked In
      </Badge>
    );
  }
  if (isReserved) {
    return (
      <Badge size='md' variant='filled' color='kiloBlue' {...props}>
        Reserved
      </Badge>
    );
  }
  if (isClass) {
    return (
      <Badge size='md' variant='filled' color='gray' {...props}>
        Unreserved
      </Badge>
    );
  }
  return null;
};

export default AthleteEventStatusBadge;
